var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnUseredit = function SvgIcnUseredit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3673_192039)",
    filter: "url(#filter0_d_3673_192039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 1.75H27C28.2426 1.75 29.25 2.75736 29.25 4V27.5128C29.25 27.6903 29.0701 27.8113 28.9057 27.7443L16.6603 22.7554C16.237 22.583 15.763 22.583 15.3397 22.7554L3.09432 27.7443C2.9299 27.8113 2.75 27.6903 2.75 27.5128V4C2.75 2.75736 3.75736 1.75 5 1.75Z",
    fill: "#2CCCD3",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12.4997C17.8409 12.4997 19.3333 11.0073 19.3333 9.16634C19.3333 7.32539 17.8409 5.83301 16 5.83301C14.159 5.83301 12.6666 7.32539 12.6666 9.16634C12.6666 11.0073 14.159 12.4997 16 12.4997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1858 18.4885L17.1872 18.4803C17.2211 18.2653 17.299 18.0653 17.3779 17.9091C17.4569 17.7529 17.5731 17.5684 17.7309 17.4104L19.8402 15.2983C18.7938 14.5896 17.4558 14.1641 16 14.1641C12.66 14.1641 9.93994 16.4041 9.93994 19.1641C9.93994 19.3507 10.0866 19.4974 10.2733 19.4974H17.044L17.1858 18.4885Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6076 14.945C22.1302 14.4488 22.737 14.2398 23.4988 15.0026C24.26 15.7648 24.0523 16.3721 23.5498 16.8872L21.6076 14.945ZM21.0415 15.5103L18.4385 18.1168C18.3155 18.24 18.2013 18.4687 18.1749 18.6358L18.008 19.8234C17.9465 20.2544 18.2452 20.5535 18.6757 20.492L19.8617 20.3248C20.0286 20.2984 20.2659 20.1841 20.3801 20.0609L22.9844 17.4531L21.0415 15.5103Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3673_192039",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3673_192039"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3673_192039",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3673_192039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(2 1)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnUseredit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_useredit.bb90faea.svg";
export { ForwardRef as ReactComponent };